import { useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import torqueUnitFor from 'config/torque-units';
import { ProjectContext } from 'components/layouts/Project';
import SlideHeader from 'components/helpers/SlideHeader';
import TorqueGraph from './report/TorqueGraph';
import CapacityGraph from './report/CapacityGraph';
import PressureGraph from './report/PressureGraph';

export default () => {
  const project = useContext(ProjectContext);
  const {settings: {lengthUnit, forceUnit}={}, data: {loads}} = project ?? {};
  const helicalLoads = _.some(loads, (load) => load?.pileType == 'helical');
  const pushPierLoads = _.some(loads, (load) => load?.pileType == 'push_pier');

  return (
    <Swiper breakpoints={{800: {slidesPerView: 2}}} loop>
      {helicalLoads && (
        <SwiperSlide>
          <SlideHeader color="primary">Torque ({torqueUnitFor(lengthUnit).abbreviation})</SlideHeader>
          <TorqueGraph project={project}/>
        </SwiperSlide>
      )}
      <SwiperSlide>
        <SlideHeader color="primary">Allowable Capacity ({forceUnit.abbreviation})</SlideHeader>
        <CapacityGraph project={project}/>
      </SwiperSlide>
      {pushPierLoads && (
        <SwiperSlide>
          <SlideHeader color="primary">Pressure (PSI)</SlideHeader>
          <PressureGraph project={project}/>
        </SwiperSlide>
      )}
    </Swiper>
  );
}
